import React from "react";

type Product = {
  name: string;
  image: string;
  url: string;
};

const products: Product[] = [
  {
    name: "コカ・コーラ 綾鷹 お茶 300ml×24本",
    image: "https://m.media-amazon.com/images/I/51jTWSh7upL._AC_SX679_PIbundle-24,TopRight,0,0_SH20_.jpg",
    url: "https://amzn.to/49jYAsL",
  },
  {
    name: "エリエール 箱ティシュー 180組×30箱(5箱×6パック) ",
    image: "https://m.media-amazon.com/images/I/61eCV8A2p0L._AC_SX679_PIbundle-6,TopRight,0,0_SH20_.jpg",
    url: "https://amzn.to/4jviGVM",
  },
  {
    name: "ゴミが出ない トイレットペーパー シングル 3倍 業務用",
    image: "https://m.media-amazon.com/images/I/61iwvZWoh1L._AC_SX679_.jpg",
    url: "https://amzn.to/4stkPoT",
  },
];

const RecommendedProducts: React.FC = () => {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl font-bold text-center mb-10">
          おすすめ商品
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {products.map((product, idx) => (
            <a
              key={idx}
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl shadow hover:shadow-lg transition p-4 flex flex-col items-center"
            >
              <img
                src={product.image}
                alt={product.name}
                className="h-40 object-contain mb-4"
              />
              <p className="text-center font-medium text-gray-800">
                {product.name}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecommendedProducts;
